import styled from "styled-components";

export const Divider = () => <StyledDivider />;

const StyledDivider = styled.div`
  margin: 6px 0;
  width: 100%;
  height: 1px;
  background: var(--bg-10);
`;
